import _ from "lodash";
export const selectActivePhones = ({ customerPhones }) =>
  _.filter(customerPhones, p => p.isActive !== false);
